var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9228 17.8831V17.8811C17.8128 17.8891 17.2458 17.9231 15.9808 17.9231C14.9708 17.9231 14.2598 17.8931 14.0098 17.8811V17.8841C10.1218 17.7131 7.21978 17.0361 7.21978 16.2261C7.21978 15.4161 10.1218 14.7401 14.0098 14.5661V17.2101C14.2638 17.2281 14.9918 17.2711 15.9978 17.2711C17.2048 17.2711 17.8098 17.2211 17.9228 17.2111V14.5681C21.8028 14.7411 24.6978 15.4181 24.6978 16.2261C24.6978 17.0361 21.8028 17.7111 17.9228 17.8831ZM17.9228 14.2931V11.9271H23.3368V8.31909H8.59578V11.9271H14.0098V14.2921C9.60978 14.4941 6.30078 15.3661 6.30078 16.4101C6.30078 17.4541 9.60978 18.3251 14.0098 18.5281V26.1101H17.9228V18.5261C22.3158 18.3241 25.6168 17.4531 25.6168 16.4101C25.6168 15.3671 22.3158 14.4961 17.9228 14.2931Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsdt);
export default __webpack_public_path__ + "static/media/icon_usdt.5d9edeb794513fba2e9e984207416f04.svg";
export { ForwardRef as ReactComponent };